export default "__VITE_ASSET__DKjK4QHv__"